import { LocateFixed } from "lucide-react";

const HEADLINE = {
  denied: "Location access is off",
  unsupported: "GPS not supported here",
  error: "Couldn't reach the satellites",
  idle: "Enable GPS to appear on the radar",
};

const BODY = {
  denied: "You blocked location. Open your browser's site settings and set Location to Allow, then reload.",
  unsupported: "Your browser can't share GPS. Try Chrome, Firefox, or Safari on a mobile device.",
  idle: "Signal Radar needs your live location to find humans nearby. Your coordinates never leave the platform, and you can turn broadcasting off any time.",
};

export function GeoPermissionBanner({ geoState, geoError, onEnable }) {
  if (geoState !== "idle" && geoState !== "denied" && geoState !== "unsupported" && geoState !== "error") {
    return null;
  }
  const body = geoState === "error" ? (geoError || "We couldn't read your location. Try again.") : BODY[geoState];
  return (
    <div
      data-testid="geo-permission-banner"
      className="mb-4 p-4 md:p-5 glass rounded-2xl border border-[#00E5FF]/25 flex flex-col md:flex-row md:items-center gap-3 justify-between"
    >
      <div className="flex items-start gap-3">
        <LocateFixed size={20} className="text-[#00E5FF] mt-0.5 shrink-0" />
        <div>
          <div className="font-[Unbounded] text-sm">{HEADLINE[geoState]}</div>
          <p className="text-xs text-white/60 mt-1 max-w-lg">{body}</p>
        </div>
      </div>
      {(geoState === "idle" || geoState === "error") && (
        <button
          data-testid="enable-gps-btn"
          onClick={onEnable}
          className="bg-[#00E5FF] text-black font-semibold text-sm px-5 py-2.5 rounded-full hover:glow-primary transition-all whitespace-nowrap"
        >
          Enable GPS
        </button>
      )}
    </div>
  );
}
